import { useRef } from "react";
import { twJoin } from "tailwind-merge";

import { TextEditor } from "src/base-components/TextEditor/TextEditor";
import { Toolbar } from "src/base-components/TextEditor/Toolbar";

export const TemplateDescriptionEditor: React.FC<{
  "data-loc"?: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}> = ({
  "data-loc": dataLoc,
  placeholder,
  value,
  onChange,
  disabled = false,
}) => {
  const toolbarRef = useRef<HTMLUListElement>(null);

  return (
    <div
      className={twJoin(
        "flex min-w-0 flex-1 flex-col break-all rounded border border-gray-200 p-3",
        disabled
          ? "border-gray-200 bg-gray-50 [&_.ql-editor]:text-gray-500"
          : "group bg-white focus-within:border-indigo-600 focus-within:ring-2 focus-within:ring-indigo-500/25",
      )}
    >
      <TextEditor
        dataLoc={dataLoc}
        placeholder={placeholder}
        readOnly={disabled}
        toolbarRef={toolbarRef}
        value={value}
        keepEmptyLines
        onChange={onChange}
      />
      {!disabled && (
        <div className="flex justify-between gap-x-3 pt-3">
          <Toolbar ref={toolbarRef} exclude={["heading"]} faded={false} />
        </div>
      )}
    </div>
  );
};
